$(function() {
	var $document = $(document);

	function initStatic() {
		initHashLinks();
		initPopover();
	}

	// Close popover on
	function initPopover() {
		$document.on('click blur','body', function(e) {
			if (typeof $(e.target).data('original-title') === 'undefined' &&
				!$(e.target).parents().is('.popover.in')) {
				$('[data-original-title]').popover('hide');
			}
		});
	}

	// Prevent navigation for <a href="#..."> and <a class="js-link"> links
	function initHashLinks() {
		$document.on('click', 'a[href^="#"], a.js-link', function(event) {
			event.preventDefault();
		});
	}

	function initDynamic($root) {
		initDisabledLinks($root);
		initTruncation($root);
		initTab($root);
		initImageLoading($root);
		initImageSpacers($root);
	}

	function initDisabledLinks($root) {
		$root.find('a').click(function(event) {
			var isDisabled = $(this).hasClass('disabled');
			if (isDisabled) {
				event.stopImmediatePropagation();
				event.preventDefault();
			}
		});
	}

	function initTruncation($root) {
		$root.find('.truncate').truncate();
	}

	function initTab($root) {
		var hash = $.getHashParams();
		var tab = hash['tab'];
		if (!tab) {
			return;
		}

		tab = tab.toLowerCase();
		var tabsByHref = $root.find('.nav a[href="#' + tab + '"]');
		var tabsByText = $root.find('.nav a').filter(function() { return $(this).text().toLowerCase() === tab; });
		$(tabsByHref)
			.add(tabsByText)
			.tab('show');
	}

	function initImageLoading($root) {
		$root.find('.img-loading').on('load error', function() {
			$(this).removeClass('img-loading');
		});
	}

	function initImageSpacers($root) {
		var IMAGE_SPACER = String.prototype.resolveUrl
			? '~/Content/Images/spacer.png'.resolveUrl()
			: '#';
		$root.find('.img-spacer').attr('src', IMAGE_SPACER);
	}

	// Initialize static html
	initStatic();
	initDynamic($document);

	// Initialize F2 apps
	$document.on('loaded', function(event) {
		var $root = $(event.target);
		initDynamic($root);
	});
});
